export default __webpack_public_path__ + "static/media/Regulamin (konkurs kreatywny).f8ba08e5.pdf";